import { IDepartments } from '../interface/interfaces';

export const departmentInitialState: IDepartments = {
    DepartmentId: 0,
    DepartmentName: '',
    Label: '',
    In: [],
    Out: [],
    Status: 'UNKNOWN',
    Actions: [],
};
